var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4283 15.2C30.5017 15.2 15.1283 30.5735 15.1283 49.5C15.1283 68.4266 30.5017 83.8 49.4283 83.8C68.3548 83.8 83.7283 68.4266 83.7283 49.5C83.7283 30.5735 68.3548 15.2 49.4283 15.2ZM34.2659 74.196C37.7135 69.2357 43.3774 66.2103 49.4283 66.2103C55.4792 66.2103 61.143 69.2005 64.6258 74.196C60.1932 76.94 55.0218 78.5231 49.4283 78.5231C43.8347 78.5231 38.6985 76.94 34.2659 74.196ZM68.8122 71.0299C64.3444 64.6976 57.1678 60.9334 49.4283 60.9334C41.6888 60.9334 34.477 64.7679 30.0444 71.0299C24.1342 65.7178 20.4052 58.0486 20.4052 49.5C20.4052 33.4934 33.4216 20.4769 49.4283 20.4769C65.4349 20.4769 78.4514 33.4934 78.4514 49.5C78.4514 58.0486 74.7223 65.7178 68.8122 71.0299Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4283 29.2718C42.1461 29.2718 36.236 35.182 36.236 42.4641C36.236 49.7463 42.1461 55.6564 49.4283 55.6564C56.7104 55.6564 62.6206 49.7463 62.6206 42.4641C62.6206 35.182 56.7104 29.2718 49.4283 29.2718ZM49.4283 50.3795C45.066 50.3795 41.5129 46.8264 41.5129 42.4641C41.5129 38.1019 45.066 34.5487 49.4283 34.5487C53.7905 34.5487 57.3437 38.1019 57.3437 42.4641C57.3437 46.8264 53.7905 50.3795 49.4283 50.3795Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.9ea79fdb.svg";
export { ForwardRef as ReactComponent };